import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { CustomizationComponent } from './customization.component';
import { CustomizationService } from './customization.service';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from '../colorPicker/color-picker.module';
import { PreviewModule } from '../preview/preview.module';
import { ImageImportModule } from '../image_import/image_import.module';
import { ImageOrIframeModule } from '../image-or-iframe/image-or-iframe.module';
import { TabsModule } from '../tabs/tabs.module';
import { TagsFilter, TagsOmit, RenderTags } from './tags.pipe';
import { EvaEditorModule } from '../eva-editor/eva-editor.module';
import { TagsFormatService } from '../tags/tags-format.service';
import { PluginsModule } from '../plugins/plugins.module';
import { PopoverModule } from 'ngx-bootstrap/popover';

@NgModule({
  declarations: [CustomizationComponent, TagsFilter, TagsOmit, RenderTags],
  exports: [CustomizationComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    PreviewModule,
    TranslateModule,
    FormsModule,
    ImageImportModule,
    ImageOrIframeModule,
    ColorPickerModule,
    TabsModule,
    EvaEditorModule,
    PluginsModule,
    PopoverModule.forRoot()
  ],
  providers: [CustomizationService, TagsFormatService]
})
export class CustomizationModule {}



// WEBPACK FOOTER //
// ./src/app/modules/customization/customization.module.ts